import React from "react";
import {SWIREPAY_URL} from "../../appconstants";
import ErrorPage from "../../components/error";

const UpiError = () => {
    return (
      <ErrorPage
        heading={'Oops!'}
        body={'We’re sorry, the bank servers are currently under maintenance. Please try again later'}
        url={SWIREPAY_URL}
        btnText={'Close'}
      />
    )
};

export default UpiError;
